import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./env";
import "element-plus/dist/index.css";

const app = createApp(App);
app.config.globalProperties.$recorder = false;
app.use(store).use(router).mount("#app");
